/* eslint-disable @typescript-eslint/ban-ts-comment */
import { FieldInputProps, useField } from 'formik';
import styled from '@emotion/styled';
import ReactSelect, { Props } from 'react-select';

// __start
// import { OptionsType, ValueType } from "react-select/lib/types";
// fuck interface react-select
type OptionsType<OptionType> = OptionType[];
type ValueType<OptionType> =
  | OptionType
  | OptionsType<OptionType>
  | null
  | undefined;
//  __end

type TTextInput<T> = {
  label: string;
  required: boolean;
  isMulti: boolean;
  field: FieldInputProps<T>;
  options: OptionsType<TOptionType>;
} & Props;

interface TOptionType {
  label: string;
  value: string;
}

function Select<T = any>({
  label,
  isMulti = false,
  ...props
}: TTextInput<T>): JSX.Element {
  const [field, state, { setValue, setTouched }] = useField(props.field.name);

  const onChange = (option: ValueType<TOptionType | TOptionType[]>) => {
    setValue(
      isMulti
        ? (option as TOptionType[]).map((item: TOptionType) => item.value)
        : (option as TOptionType).value,
    );
  };

  return (
    <Wrap>
      <ReactSelect
        {...props}
        classNamePrefix="form-select-prefix"
        placeholder={
          <>
            {label}{' '}
            {props.required ? <span className="text-yellow">*</span> : ''}
          </>
        }
        isMulti={isMulti}
        // @ts-ignore: Unreachable code error
        onChange={onChange}
        // @ts-ignore: Unreachable code error
        onBlur={setTouched}
      />
    </Wrap>
  );
}

export default Select;

const Wrap = styled.div`
  margin-bottom: 16px;

  .form-select-prefix {
    &__control {
      min-height: 47px;
      background-color: transparent;
      border-radius: 0;
      border: 0;
      border-bottom: 3px solid #444052;
      box-shadow: unset;
    }

    &__value-container {
      padding: 2px 7px;
    }

    &__placeholder,
    &__single-value {
      font-weight: 500;
      font-size: 14px;
      color: var(--white);
    }

    &__menu {
      background-color: #151027;
      border: 2px solid #444052;
      margin-top: -2px;
      border-radius: 0;
    }

    &__indicator-separator {
      width: 0;
    }

    &__option {
      padding: 12px 32px;
      font-size: 14px;
      font-weight: 500;

      &--is-focused {
        background-color: var(--purple-darken2);
      }
    }
  }
`;
